import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The volt hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a bright teal + sunny-yellow palette for a curious
 * little inventor. Choosing him recolours the WHOLE kid shell: the brand ramp drives buttons / meters / rings
 * in teal, the canvas blooms cool-to-warm to a teal+yellow dawn, and the hero stage takes his workshop-dusk
 * sky. Every brand colour is paired with its own foreground for legibility.
 */
export const voltTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — bright teal. `soft`→`primary` is the button/meter gradient (white text); `deep` is on-light
  // text; `tint` is the softest fill; `glow-rgb` = #18827C for coloured shadows.
  '--color-primary': '#18827C',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#36A39C',
  '--color-primary-deep': '#0E6B66',
  '--color-primary-tint': '#DFF4F2',
  '--color-primary-glow-rgb': '24 130 124',
  '--color-secondary': '#DCEDEB',
  '--color-secondary-fg': '#1C3F3C',
  '--color-accent': '#F4C542',
  '--color-accent-fg': '#4A3900',
  // CANVAS — a soft teal bloom top-left, a sunny yellow bloom bottom-right (a bright workshop dawn).
  '--canvas-a': '#DFF4F2',
  '--canvas-b': '#FCF3D8',
  // A deep teal workshop dusk, warmed by a lamplight glow (white text stays AA over it).
  '--sky-top': '#132b30',
  '--sky-mid': '#1f5c58',
  '--sky-low': '#7fd4c7',
  '--sky-glow': '#ffe2a0',
  '--sky-fg': '#ffffff',
});
